import { useContext, useState } from "react";
import { Dropdown, DropdownSkeleton } from "carbon-components-react";
import { Label } from "../Label";

import useSWR from "swr";
import { URL, Fetcher as F } from "../../../api";
import { CentersContext, UserContext } from "../../../context";

export const VisitSchedule = ({
  id,
  className,
  style,
  filter = {},
  field = {},
  data,
  onChange,
}) => {
  const { center } = filter;
  const { key, required = false } = field;
  const title = "預約時段";

  const [shouldValidate, setShouldValidate] = useState(false);
  const invalid = shouldValidate && required && data === undefined;

  const {
    token: { access },
  } = useContext(UserContext);

  // Must had center.id, no id use first one
  const center_id = center?.id ?? 1;

  const { list: centerList = [] } = useContext(CentersContext) || {};
  const centerFromList = centerList.find((x) => x.id === center_id);
  const vsDictFromContext = centerFromList?.visit_schedules.items ?? null;

  // when vsDictFromContext no data, need to fetch again.
  const needFetch = access && !vsDictFromContext;
  const url = `${URL.center}${center_id}/`;
  const { data: ccData } = useSWR(needFetch && [url], F.withToken);
  const vsDictFromFetch = ccData?.visit_schedules.items ?? {};

  const vsDict = !!vsDictFromContext ? vsDictFromContext : vsDictFromFetch;
  // use filter to clean empty item
  const visitScheduleList = Object.keys(vsDict)
    .map((x) => vsDict[x])
    .filter((x) => x);
  const item = (visitScheduleList || []).find((x) => x === data);

  return !visitScheduleList ? (
    <DropdownSkeleton id={id} className={className} style={style} />
  ) : (
    <Dropdown
      id={id}
      className={className}
      style={style}
      titleText={<Label required={required}>{title}</Label>}
      label="請選擇"
      items={visitScheduleList}
      itemToString={(x) => x}
      selectedItem={item}
      invalid={invalid}
      invalidText="此為必填欄位"
      onFocus={() => setShouldValidate(false)}
      onBlur={() => setShouldValidate(true)}
      onChange={(e) => {
        const v = e.selectedItem;
        if (typeof onChange !== "function") return;
        onChange({ [key]: v });
      }}
    />
  );
};
